export default "__VITE_ASSET__DWT82lOx__"